import React, { useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionSummaryText, BladeModal } from '@monavate/ui-core';
import styled from 'styled-components';
import { KeyValueViewer } from '@monavate/ui-core';
import { createIbanAddressObject, createIbanDetailsObject } from './helper';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reduxStore/rootReducer';
import { closeIbanClientDetailsModal } from '@/reduxStore/slices/ibansSlice';
import { getCurrencySign } from '@/helpers/currency';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface IbanDetailsBladeModalProps {
    isOpen: boolean;
}

const Header = styled.div`
    padding: 32px 32px 24px;
    background: ${(props) => props.theme['Surface/secondary']}
        /* TODO: check color. Alternatives: ["Surface/secondary","Interaction/hover","Interaction/active","Interaction/selected","Interaction/focus","Interaction/disabled"] */;
`;

const MainTitle = styled.div`
    color: ${(props) => props.theme['Content/primary']}
        /* TODO: check color. Alternatives: ["Content/primary","Content/logo","Content/on-accent"] */;
    font-family: 'Poppins', serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;

const SecondaryTitle = styled.div`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: ${(props) => props.theme['Content/secondary']};
    line-height: 22px;
`;

const AccordionWrap = styled.div`
    border-top: 1px solid ${(props) => props.theme['Content/secondary']}
        /* TODO: check color. Alternatives: ["Content/secondary","Borders/quiet"] */;
    #iban-header {
        background: ${(props) => props.theme['Surface/secondary']}
            /* TODO: check color. Alternatives: ["Surface/secondary","Interaction/hover","Interaction/active","Interaction/selected","Interaction/focus","Interaction/disabled"] */ !important;
    }
`;

const AccordionDetailsWrap = styled.div`
    padding: 8px 32px 16px;
`;

interface BladeModalHeaderProps {
    currency?: string;
}
const BladeModalHeader = ({ currency }: BladeModalHeaderProps) => {
    return (
        <Header>
            <MainTitle>IBAN details</MainTitle>
            <SecondaryTitle>
                {getCurrencySign(currency || '')} {currency}
            </SecondaryTitle>
        </Header>
    );
};

const IbanClientDetailsBladeModal: React.FC<IbanDetailsBladeModalProps> = ({ isOpen }) => {
    const dispatch = useDispatch();
    const ibanToDisplay = useSelector((state: RootState) => state.ibans.ibanToDisplay);

    useEffect(() => {
        return () => {
            onCloseModalHandler();
        };
    }, []);

    const onCloseModalHandler = () => {
        dispatch(closeIbanClientDetailsModal());
    };

    return (
        <BladeModal
            isOpen={isOpen && !!ibanToDisplay}
            closeButton={true}
            handleClose={onCloseModalHandler}
            padding={'0'}
            customHeader={<BladeModalHeader currency={ibanToDisplay?.currency || ''} />}
        >
            <AccordionWrap>
                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="iban-header">
                        <AccordionSummaryText>Account</AccordionSummaryText>
                    </AccordionSummary>
                    <AccordionDetailsWrap>
                        <KeyValueViewer data={createIbanDetailsObject(ibanToDisplay)} />
                    </AccordionDetailsWrap>
                </Accordion>

                <Accordion defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="iban-header">
                        <AccordionSummaryText>Address</AccordionSummaryText>
                    </AccordionSummary>
                    <AccordionDetailsWrap>
                        <KeyValueViewer data={createIbanAddressObject(ibanToDisplay?.address)} />
                    </AccordionDetailsWrap>
                </Accordion>
            </AccordionWrap>
        </BladeModal>
    );
};

export default IbanClientDetailsBladeModal;
